import Phaser from 'phaser';
import { createGameConfig } from './game/config';
import { mountDevHarness } from './harness/DevHarness';
import { mountAccessibilityLayer } from './accessibility/AccessibilityLayer';

const config = createGameConfig('app');
const game = new Phaser.Game(config);

// Canvas conveys nothing meaningful to assistive tech on its own (see CP22
// fix) - hide it from the accessibility tree entirely and rely on the real
// DOM controls + aria-live region (mountAccessibilityLayer, below) as the
// parallel accessible surface instead of exposing an empty/confusing node.
game.events.once(Phaser.Core.Events.READY, () => {
  const canvas = game.canvas;
  if (!canvas) return;
  canvas.setAttribute('role', 'presentation');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.tabIndex = -1;
});

mountAccessibilityLayer();

if (import.meta.env.DEV) {
  mountDevHarness();
}
